/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Operatinghours1Inputs */



/**
* | output |
* | --- |
* | "Operating hours" |
*
* @param {Ahu_History_Key_Operatinghours1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_operatinghours1 = /** @type {((inputs?: Ahu_History_Key_Operatinghours1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Operatinghours1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Operating hours")
	return /** @type {LocalizedString} */ ("Temps de fonctionnement")
});
export { ahu_history_key_operatinghours1 as "ahu_history_key_operatingHours" }